import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Layout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="admin-layout">
      <aside className="sidebar">
        <div className="sidebar-title">
          <span>🧙‍♀️</span>
          <span>Admin Panel</span>
        </div>

        <nav>
          <Link to="/" className={`nav-item ${isActive('/')}`}>
            📊 Dashboard
          </Link>
          <Link to="/languages" className={`nav-item ${isActive('/languages')}`}>
            🌍 Languages
          </Link>
          <Link to="/lexemes" className={`nav-item ${isActive('/lexemes')}`}>
            📚 Lexemes
          </Link>
          <Link to="/translations" className={`nav-item ${isActive('/translations')}`}>
            📝 Translations
          </Link>
          <Link to="/courses" className={`nav-item ${isActive('/courses')}`}>
            🎓 Courses
          </Link>
          <Link to="/users" className={`nav-item ${isActive('/users')}`}>
            👥 Users
          </Link>
          <Link to="/premium-codes" className={`nav-item ${isActive('/premium-codes')}`}>
            ⭐ Premium Codes
          </Link>
        </nav>

        <div style={{ marginTop: 'auto', paddingTop: '24px', borderTop: '1px solid rgba(126, 63, 242, 0.3)' }}>
          <div style={{ padding: '12px', marginBottom: '12px' }}>
            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{user?.username}</div>
            <div style={{ fontSize: '12px', color: 'rgba(243, 234, 255, 0.6)' }}>{user?.email}</div>
          </div>
          <button
            onClick={handleLogout}
            className="btn btn-secondary"
            style={{ width: '100%' }}
          >
            Logout
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
